import { getConfigValue } from '@jutro/config';
import { warning, info } from '@jutro/logger';
import { fetchTsmLanguages } from './fetchTsmLanguages';
export const tsmLanguagesLoader = async () => {
  const worksetUid = getConfigValue('JUTRO_TSM_WORKSET_UID', 'active');
  const stringVersion = getConfigValue('JUTRO_TSM_STRING_VERSION');
  const stringGroup = getConfigValue('JUTRO_TSM_STRING_GROUP');
  const config = getConfigValue('localeSettings');
  const jutroVersion = getConfigValue('JUTRO_CORE_STRING_VERSION');
  info("TSM enabled: Loading available languages, worksetUid: \"".concat(worksetUid, "\", string group: \"").concat(stringGroup, ":."));
  try {
    const languages = await fetchTsmLanguages(worksetUid, stringGroup, undefined, stringVersion, jutroVersion);
    config.availableLanguages = languages.languageCodes;
    config.preferredLanguage = languages.defaultLanguageCode;
  } catch (err) {
    warning("TSM: Error loading languages. Details: ".concat(err));
  }
};